var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 24,
    viewBox: "0 0 45 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 8H23.8C22.16 3.34 17.72 0 12.5 0C5.88 0 0.5 5.38 0.5 12C0.5 18.62 5.88 24 12.5 24C17.72 24 22.16 20.66 23.8 16H24.5L28.5 20L32.5 16L36.5 20L44.5 11.92L40.5 8ZM12.5 18C9.2 18 6.5 15.3 6.5 12C6.5 8.7 9.2 6 12.5 6C15.8 6 18.5 8.7 18.5 12C18.5 15.3 15.8 18 12.5 18Z",
    fill: "#8F8D96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSso);
export default __webpack_public_path__ + "static/media/sso.864fa53b3030de8fcfc4f6da734c9f61.svg";
export { ForwardRef as ReactComponent };